/* Reader text size: S / M / L, remembered per browser */
(function () {
    'use strict';

    var control = document.querySelector('[data-size-control]');
    var content = document.querySelector('[data-content]');
    if (!control || !content) {
        return;
    }

    var STORAGE_KEY = 'vanta-plus-text-size';
    var buttons = control.querySelectorAll('[data-size]');

    function apply(size) {
        if (size === 'm') {
            content.removeAttribute('data-size');
        } else {
            content.setAttribute('data-size', size);
        }
        buttons.forEach(function (button) {
            button.setAttribute('aria-pressed', String(button.getAttribute('data-size') === size));
        });
    }

    var saved = null;
    try {
        saved = localStorage.getItem(STORAGE_KEY);
    } catch (e) {
        saved = null;
    }
    if (saved === 's' || saved === 'l') {
        apply(saved);
    }

    control.addEventListener('click', function (event) {
        var button = event.target.closest('[data-size]');
        if (!button) {
            return;
        }
        var size = button.getAttribute('data-size');
        apply(size);
        try {
            localStorage.setItem(STORAGE_KEY, size);
        } catch (e) {
            /* storage unavailable */
        }
    });
})();
